import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
    ActivatedRouteSnapshot,
    PRIMARY_OUTLET,
    RouterStateSnapshot,
    TitleStrategy,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, combineLatest, of, switchMap } from 'rxjs';

const DEFAULT_PAGE_TITLE_KEY = 'HTML_PAGE_TITLE';

@Injectable()
export class TranslateServiceTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);
    private readonly translateService = inject(TranslateService);
    private readonly titleKey$ = new BehaviorSubject('');

    constructor() {
        super();
        combineLatest([
            this.translateService.onTranslationChange,
            this.titleKey$,
        ])
            .pipe(
                switchMap(([, titleKey]) =>
                    titleKey ? this.translateService.stream(titleKey) : of(''),
                ),
            )
            .subscribe((title) => {
                this.title.setTitle(title);
            });
    }

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const titleFromActivatedRoute =
            this.buildTitle(snapshot) || DEFAULT_PAGE_TITLE_KEY;
        const component = getActivatedRouteComponentInstance(snapshot);
        if (component?.prototype.translateKeyPrefix) {
            const translateKeyPrefix = component.prototype.translateKeyPrefix;
            const titleKey = `${translateKeyPrefix}.${titleFromActivatedRoute}`;
            this.titleKey$.next(titleKey);
        } else {
            this.title.setTitle('');
        }
    }
}

function getActivatedRouteComponentInstance(snapshot: RouterStateSnapshot) {
    let component;
    let route: ActivatedRouteSnapshot | undefined = snapshot.root;
    while (route !== undefined) {
        component = route.component;
        route = route.children.find((child) => child.outlet === PRIMARY_OUTLET);
    }
    return component;
}
